import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CARD_INFORME_PENSIONES } from '@constants/informe-pensiones.constants';
import { IActionsInformePensiones } from '@interfaces/actions-informe-pensiones.interface';

@Component({
    selector: 'app-actions-grid',
    templateUrl: './actions-grid.component.html',
    styleUrl: './actions-grid.component.scss',
    standalone: false
})
export class ActionsGridComponent {

  actions: IActionsInformePensiones[] = CARD_INFORME_PENSIONES;

  constructor(private readonly router: Router) { }

  goToAction(action: IActionsInformePensiones) {
   this.router.navigate([action.link]);
  }
}
